// extracted by mini-css-extract-plugin
export const detailsCard = "details-card-module--details-card--3Jw6u";
export const iconWrapper = "details-card-module--icon-wrapper--9Aghg";
export const icon = "details-card-module--icon--1f8Jg";
export const black = "details-card-module--black--i1Nv0";
export const tealTheBurn = "details-card-module--tealTheBurn--2lNHQ";
export const black10 = "details-card-module--black10--3YFb4";
export const hilitLime = "details-card-module--hilitLime--34445";
export const movemintLight = "details-card-module--movemintLight--2V0Eu";